export var version = '6.6.5'; // Note: This file is automatically generated when building math.js.
// Changes made in this file will be overwritten.


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/version.js
// module id = 2030
// module chunks = 0